var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCrossReverse = function SvgCrossReverse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cross-reverse_svg__a)",
    fill: "#053249"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8a1 1 0 0 0-1.415 0L12 10.586 9.413 8A1 1 0 0 0 8 9.414L10.586 12l-2.587 2.586A1 1 0 0 0 9.413 16L12 13.414 14.585 16A1 1 0 0 0 16 14.586L13.415 12l2.585-2.586A1 1 0 0 0 16 8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0a12 12 0 1 0 12 12A12.013 12.013 0 0 0 12 0Zm0 22a10 10 0 1 1 10-10 10.01 10.01 0 0 1-10 10Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cross-reverse_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgCrossReverse;